export interface BasecampRoomAccessCodeData {
  roomNumber: string;
  roomType: string | null;
  currentAccessCode: string | null;
}

// These VIP room keypads require # to submit the access code.
const VIP_ROOMS_REQUIRING_HASH = new Set([
  '305',
  '401',
  '403',
  '501',
  '601',
  '602',
  '702',
  '704',
  '705',
  '801',
  '804',
  '805',
  '902',
  '903',
  '904',
  '905',
  '1004',
  '1101',
  '1103',
  '1104',
  '1201',
  '1205',
  '1303',
  '1304',
  '1402',
  '1403',
  '1404',
  '1405',
]);

export function formatBasecampRoomAccessCode({
  roomNumber,
  roomType,
  currentAccessCode,
}: BasecampRoomAccessCodeData): string | null {
  const number = roomNumber.trim().replace(/^VIP\s*/i, '');
  if (roomType !== 'VIP' || !VIP_ROOMS_REQUIRING_HASH.has(number)) {
    return currentAccessCode;
  }

  const code = currentAccessCode?.trim();
  if (!code || code.endsWith('#')) {
    return currentAccessCode;
  }

  return `${code}#`;
}
